import GroupsCard from "./GroupsCard"

export default  GroupsCard;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/Groups/GroupsCard/index.js